export default __webpack_public_path__ + "images/onboarding/math-cart-d57462b40cf1fd8492d3506d0153d160.svg";